import { Layout } from "@vwfs-bronson/bronson-react";
import SecondAuthHeader from "../../components/authentication/secondAuthPage/SecondAuthHeader";
import SecondAuthForm from "../../components/authentication/secondAuthPage/SecondAuthForm";
import { StepsWizard } from "../../components/common/StepsWizard";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { trackOnSecondAuthPage } from "../../adobeTracking/trackers";
import { useNotification } from "../../hooks/useNotification";

export const SecondAuthFactor = () => {
  const { auth, authResponse } = useAuth();
  const navigate = useNavigate();
  const { handleDeleteAllNotifications } = useNotification();
  useEffect(() => {
    if (!auth || !authResponse) {
      handleDeleteAllNotifications();
      navigate("/");
      return;
    }
    trackOnSecondAuthPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Layout center>
      <StepsWizard activeStep={2} />
      <SecondAuthHeader />
      <SecondAuthForm />
    </Layout>
  );
};
